const FALLBACK_ROUTE_COLOR = '#a0a0a0';
const FALLBACK_TRUCK_COLOR = '#a0a0a0';
const FALLBACK_PING_COLOR = '#FFFFFF';
const FALLBACK_ROUTE_POINT_COLOR = '#a0a0a0';

/**
 * Route colors always come from the legend API (route_legend), never
 * hardcoded here, so a backend color change is picked up automatically.
 */
export const getRouteColor = (dataSource, routeLegend = []) => {
  const match = routeLegend.find((entry) => entry.data_source === dataSource);
  return (match && match.color) || FALLBACK_ROUTE_COLOR;
};

/**
 * Shared shape behind truck_legend and ping_legend: entries keyed by `type`
 * (including a `type: null` catch-all), each optionally carrying a
 * `sub_types` list keyed by `sub_type`. A sub_type match wins over the
 * parent type's own entry.
 */
const resolveTypedEntry = (type, subType, legend) => {
  const normalizedType = type === undefined ? null : type;
  const typeEntry = legend.find((entry) => entry.type === normalizedType) || {};
  const subTypeEntry = (typeEntry.sub_types || []).find((entry) => entry.sub_type === subType);
  return subTypeEntry || typeEntry;
};

export const getTruckColor = (type, subType, truckLegend = []) => (
  resolveTypedEntry(type, subType, truckLegend).code || FALLBACK_TRUCK_COLOR
);

/**
 * The human-readable status a truck/trip resolves to (e.g. "IN-TRANSIT",
 * "STOPPED") - same resolution as getPingStatus, against truck_legend.
 */
export const getTruckStatus = (type, subType, truckLegend = []) => (
  resolveTypedEntry(type, subType, truckLegend).status || 'Unknown'
);

/**
 * GPS ping color, resolved from the legend API's ping_legend (never
 * hardcoded), same type/sub_type shape as truck_legend.
 */
export const getPingColor = (type, subType, pingLegend = []) => (
  resolveTypedEntry(type, subType, pingLegend).code || FALLBACK_PING_COLOR
);

/**
 * The human-readable status a ping resolves to (e.g. "DELAYED") - used to
 * group/filter pings by kind in the map layers drawer.
 */
export const getPingStatus = (type, subType, pingLegend = []) => (
  resolveTypedEntry(type, subType, pingLegend).status || 'Unknown'
);

/**
 * Route waypoint pin color, resolved from the legend API's
 * route_point_legend (never hardcoded). Only the very first point (index 0)
 * is "source" - every other point, including the last one, is colored as
 * "destination" (labeling text is separate: only the last gets the "D"
 * label, in-between points just get a number).
 */
export const getRoutePointColor = (index, routePointLegend = []) => {
  const location = index === 0 ? 'source' : 'destination';
  const match = routePointLegend.find((entry) => entry.location === location);
  return (match && match.color) || FALLBACK_ROUTE_POINT_COLOR;
};
